import { Component, EventEmitter, Input, Output, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ModalMenuData {
  label: string;
  value: string | number;
  disabled?: boolean;
}

@Component({
  selector: 'app-modal-menu-wrapper',
  template: `
    <app-modal-menu
      [list]="data.list"
      (decide)="onDecide($event)"
    ></app-modal-menu>
  `,
})
export class ModalMenuWrapper {
  constructor(
    public dialogRef: MatDialogRef<ModalMenuWrapper>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onDecide(result: any) {
    this.dialogRef.close(result);
  }
}

@Component({
  selector: 'app-modal-menu',
  templateUrl: './modal-menu.component.html',
  styleUrls: ['./modal-menu.component.scss'],
})
export class ModalMenuComponent {
  @Input() list: ModalMenuData[] = [{ label: '変更', value: 1 }];
  @Input() cancelLabel: string = '閉じる';

  @Output() decide: EventEmitter<any> = new EventEmitter();

  select(value: any) {
    this.decide.emit(value);
  }
  cancel() {
    this.decide.emit(null);
  }
}
